
        import { Component } from 'vue-property-decorator';
    import RepsolFilterBarComponent from '@/components/repsol-filter-bar/RepsolFilterBarComponent.vue';
    import RepsolFilterChipsComponent from '@/components/repsol-filter-chips/RepsolFilterChipsComponent.vue';
    import RepsolTableComponent from '@/components/repsol-table/RepsolTableComponent.vue';
    import RepsolFormPopupComponent from '@/components/repsol-form-popup/RepsolFormPopupComponent.vue'
    import { Chip, FormFields, FilterFields, TableHeaderModel } from  '@/models/repsol-template.model';
    import ComponentBase from '@/mixins/componentBase';

    @Component({
        name: 'NotificacionesPage',
        components: {
            RepsolFilterBarComponent,
            RepsolFilterChipsComponent,
            RepsolTableComponent,
            RepsolFormPopupComponent
        },
    })

    export default class NotificacionesPage extends ComponentBase {

        isOpenFilters = false;
        isOpenForm = false;
        formIsValid = true;
        formOnlyRead = false;
        items:any[] = [];
        deleteFilter = "";
        popupHeaderText = "";
        itemEdit:any = {};
        filterChips:Chip[] = [];
        formFields : FormFields[] = [];
        filterFields : FilterFields[] = [];
        tableHeaders:TableHeaderModel[] = [];

        tableLoading = false;
        totalItems = 0;

        tableOptions = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [] as string[],
        sortDesc: [] as boolean[],
      };

        constructor() {
          super();
        }

        mounted() {
            this.formFields = [

                {
                    label: 'notificaciones.message',
                    name: 'mensaje',
                    as: 'text',
                    model: '',
                    isDisabled: false,
                    isRequired: false,
                    canView: true,
                    cols: 12
                },

                {
                    label: 'notificaciones.created_at',
                    name: 'creadoEn',
                    as: 'date',
                    model: '',
                    isDisabled: false,
                    isRequired: false,
                    canView: true,
                    cols: 8
                }
            ];

            this.filterFields = [
                {
                    label: 'notificaciones.contains_message',
                    name: 'mensaje',
                    as: 'text',
                    model: '',
                    isDisabled: false,
                    isRequired: false
                },
                {
                    label: 'notificaciones.from_date',
                    name: 'fechaDesde',
                    as: 'date',
                    model: '',
                    isDisabled: false,
                    isRequired: false
                },
                {
                    label: 'notificaciones.to_date',
                    name: 'fechaHasta',
                    as: 'date',
                    model: '',
                    isDisabled: false,
                    isRequired: false
                }
            ];

            this.tableHeaders = [
            { text: 'notificaciones.notification', value: "mensaje", sortable: false, as: 'text' },
            { text: 'notificaciones.date', value: "creadoEn", sortable: true, as: 'date' }
            ];

            this.obtenerNotificaciones();
        }

        onTableOptionsChanged(options: any) {
        this.tableOptions = { ...options };
        this.obtenerNotificaciones();
        }


        async obtenerNotificaciones(){
            try{

                this.openSpinner("notificaciones.cargarNotificaciones");
                this.items = [];
                const filtro : any = {};
                this.filterFields.forEach(f =>{
                    if(f.model){
                        filtro[f.name] = f.model;
                    }
                });

                const page = this.tableOptions?.page ?? 1;
            const itemsPerPage = this.tableOptions?.itemsPerPage ?? 10;
            const sortBy = this.tableOptions?.sortBy ?? [];
            const sortDesc = this.tableOptions?.sortDesc ?? [];
            filtro.PageNumber = page || 1;
            filtro.PageSize = itemsPerPage || 10;

            if (sortBy && sortBy.length) {
                filtro.sortBy = sortBy[0];
                filtro.sortDesc = !!(sortDesc && sortDesc[0]);
            }

                const route = '/api/notificacion/list';
                let data = await this.post({ apiUrl: route, entity: filtro })
                console.log(data.items);
                if (Array.isArray(data.items)) {
                    this.items = data.items;
                    this.totalItems = data.totalCount ?? 0;
            } else {
                    this.items = data?.items ?? [];
                    this.totalItems = data?.totalCount ?? 0;
                }
                }catch {
                this.mostrarKO("notificaciones.koNotificaciones");
                }
                this.closeSpinner();

        }

        tableEventAction(action:string, item:any): void{
            switch (action) {
                case 'eliminar':
                    this.items = this.items.filter(i => i.codigoAviso != item.codigoAviso);
                    break;
                case 'editar':

                    this.popupHeaderText = "notificaciones.editarElemento";

                    this.itemEdit = structuredClone(item);
                    this.isOpenForm = true;
                    break;
                default:
                    break;
            }
        }

        formEventAction(action:string, item:any): void{
            switch (action) {
                case 'salvar':

                    break;
                case 'cancelar':
                    this.isOpenForm = false;
                    break;

                case 'cambio':

                    break;
                default:
                    break;
            }
        }

        changeFilters(): void {
            this.filterChips.splice(0);
            this.filterFields.forEach(f =>{
                if(f.model){
                    if(Array.isArray(f.model)){
                        f.model.forEach(m =>{
                            this.filterChips.push({clave:`${f.name}-${m.id}`, valor:m.nombre, tooltip: f.label});
                        })
                    }
                    else
                    {
                        this.filterChips.push({clave:`${f.name}`, valor: f.model as string , tooltip: f.label});
                    }
                }
            });

            this.isOpenFilters = false;
            this.obtenerNotificaciones();
        }

        removeChip(clave: string): void {
            if(clave){
                this.filterChips = this.filterChips.filter(c => c.clave != clave);
                var name = clave.split('-')[0];
                var field = this.filterFields.find(f => f.name == name);
                if(field){
                    if(Array.isArray(field.model)){
                        var id = clave.split('-')[1];
                        field.model = field.model.filter(m => m.id != id);
                    }
                    else
                    {
                        field.model = '';
                    }
                }
                this.obtenerNotificaciones();
            }
        }
    }
